import React from "react";
import withStyles from '@mui/styles/withStyles';
import ExpiresAt from ".//expires-at";

const styles = (theme) => ({
  coupon: {
    color: "#383838",
    borderRadius: "15px 15px 15px 40px",
    margin: "19px 18px",
    boxShadow: "0px 3px 20px #00000024",
  },
  campaignImage: {
    alignSelf: "center",
    width: "100%",
    height: "194px",
    borderRadius: "15px 15px 0px 40px",
    objectFit: "cover",
  },
  title: {
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: "8px",
    letterSpacing: "-1.12px",
    textTransform: "capitalize",
  },
  subtitle: {
    fontSize: "12px",
    marginTop: "2px",
    color: "#8C8C96",
  },
  pointsWrapper: {
    textAlign: "center",
    borderLeft: "1px solid #EAEAEA",
    padding: "10px 20px",
    fontWeight: "bold",
  },
  pointsNumber: {
    fontSize: "18px",
    color: "#8C8C96",
  },
  pointsName: {
    fontSize: "10px",
    color: "#C0C0C9",
    textTransform: "uppercase",
    letterSpacing: "0px",
  },
});
const CouponCampaign = ({ classes, campaign, onClick }) => {
  return (
    <div className={classes.coupon} onClick={onClick}>
      <img
        src={campaign.coverImageUrl}
        alt="Campaign"
        className={classes.campaignImage}
      />
      <div style={{ padding: "11px 0px" }} className="flex justify-between">
        <div style={{ paddingLeft: "18px" }}>
          <div className={classes.title}>{campaign.title}</div>
          <div className={classes.subtitle}>{campaign.subtitle}</div>
          <div className={classes.subtitle}>
            <ExpiresAt date={campaign.expiresAt} />
          </div>
        </div>
        <div className={classes.pointsWrapper}>
          <div className={classes.pointsNumber}>{campaign.points}</div>
          <div className={classes.pointsName}>PUNKTE</div>
        </div>
      </div>
    </div>
  );
};
export default withStyles(styles)(CouponCampaign);
